import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";
import React, { useState } from "react";
import Form from "./form";
import { Modal, Spinner } from "react-bootstrap";

function FactAdmin() {

  const [viewData, setViewData] = useState("input");
  const [dataMaster, setDataMaster] = useState();
  const [dataHouses, setDataHouses] = useState();
  const [dataMerchandise, setDataMerchandise] = useState();
  const [dataOptions, setDataOptions] = useState();
  const [dataYears, setDataYears] = useState();
  const [is_direct, setIsDirect] = useState(false);
  const [is_consolidated, setIsConsolidated] = useState(false);
  const [is_parcial, setIsParcial] = useState(true);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const formatMaster = (value) => {
    let v = value.replace(/\D/g, "");

    if (v.length > 11) v = v.slice(0, 11);

    if (v.length > 3) {
      v = v.slice(0, 3) + "-" + v.slice(3);
    }

    return v;
  };

  const handleValidateMaster = async (data) => {
    setLoading(true);
    const params = {
      awb: data.inputMaster
    }

    try {

      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_administrative_billing/fact_admin_data`,
        params,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (response.data.code === 1) {
        setLoading(false);
        setViewData("form");
        setDataMaster(response.data.data.master);
        setDataHouses(response.data.data.houses);
        setDataMerchandise(response.data.data.merchandise_types);
        setDataOptions(response.data.data.options);
        setDataYears(response.data.data.years);
        setIsDirect(response.data.data.is_direct);
        setIsConsolidated(response.data.data.is_consolidated);
        setIsParcial(response.data.data.is_parcial);

      }

    } catch (error) {
      setLoading(false);
      if (error.response.data.code === -1) {
        Swal.fire("Error", error.response.data.message, "error");
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      }
    }
  }

  return (
    <>
      <Helmet>
        <title>Horus | Aceptación</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        {viewData === "input" && (
          <div className="row justify-content-center">
            <form className="col-6" onSubmit={handleSubmit(handleValidateMaster)}>
              <label htmlFor="inputMaster" className="amc-label">
                Master
              </label>
              <input
                type="text"
                className="form-control"
                id="inputMaster"
                {...register("inputMaster", {
                  required: "Este campo es requerido",
                  pattern: {
                    value: /^\d{3}-\d{8}$/,
                    message: "Formato invalido"
                  },
                  onChange: (e) => {
                    e.target.value = formatMaster(e.target.value);
                  }
                })}
              />
              {errors.inputMaster && <small className="text-danger">{errors.inputMaster.message}</small>}
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" type='submit'>
                  Buscar
                </button>
              </div>
            </form>
          </div>
        )}

        {viewData === "form" && (
          <Form
            master={dataMaster}
            houses={dataHouses}
            merchandise_types={dataMerchandise}
            options={dataOptions}
            years={dataYears}
            is_direct={is_direct}
            is_consolidated={is_consolidated}
            is_parcial={is_parcial}
            goBack={() => setViewData("input")}
          />
        )}
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  )
}

export default FactAdmin;